import { call, put, takeEvery } from 'redux-saga/effects'
import { api } from '../services/api'
import {
  UPDATE_PASSWORD_PENDING,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_FAIL,
} from '../actions/index'

function* startUpdating(action) {
  try {
    const user = yield call(api.updatePassword, action.payload, '')
    yield put({type: UPDATE_PASSWORD_SUCCESS, payload: user})
  } catch (e) {
    yield put({type: UPDATE_PASSWORD_FAIL, payload: e.message})
  }
}

function* updatePassword() {
  yield takeEvery(UPDATE_PASSWORD_PENDING, startUpdating)
}

export default updatePassword



// WEBPACK FOOTER //
// ./src/sagas/update-password.js